/**
 * What a position may rest on: the invention's numbered elements.
 *
 * An element awaiting the attorney's attention has no number and is not
 * offered, since a position cannot rest on something the invention has not
 * yet taken in. The label pairs the number with the full agreed wording.
 */

import type {
  InventionElementResponse,
  InventionElementsResponse,
} from "@patent-studio/api-types";

export interface MappableElement {
  element_id: string;
  number: number;
  text: string;
}

export function mappableElements(
  invention: InventionElementsResponse | undefined,
): MappableElement[] {
  return (invention?.elements ?? []).flatMap((e: InventionElementResponse) =>
    e.number === null
      ? []
      : [{ element_id: e.element_id, number: e.number, text: e.text }],
  );
}

export function elementLabel(element: MappableElement): string {
  return `Element ${element.number} · ${element.text}`;
}

/** The mapped elements in mapping order, skipping any the invention no longer holds. */
export function mapped(
  elementIds: readonly string[],
  elements: readonly MappableElement[],
): MappableElement[] {
  return elementIds.flatMap((id) => {
    const found = elements.find((e) => e.element_id === id);
    return found === undefined ? [] : [found];
  });
}
